import React, { useState } from "react";
import { Plus, Package } from "lucide-react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
// import UnitList from "./UnitList/UnitList";
// import UnitModal from "./UnitModal/UnitModal";
import "./ArticleGroupsPage.scss";
import DataGridWithActions from "../../Components/DataGridWithActions";
// import UnitModal from "./UnitModal";
import { AddAnElementButton } from "../../Components/AddElementsButton";
import {
  deleteAlert,
  errorAlert,
  handleSuccess,
  infoAlert,
  updateAlert,
} from "../../Components/Alerts";
import { fetchArticleGroups } from "../../Services/FetchArticleGroups";
import { createArticleGroup, deleteArticleGroup, updateArticleGroup } from "./ArticleGroupService";
import ArticleGroupModal from "./ArticleGroupModal";
import CrudPageHeader from "../../Components/CrudPageHeader";

export default function ArticleGroupsPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingGroups, setEditingGroups] = useState(null);
  // const [searchQuery, setSearchQuery] = useState("");
  

  const queryClient = useQueryClient();

  // ------------------ React Query: Fetch groups (object form v5) ------------------
  const { data: articleGroups = [], isLoading } = useQuery({
    queryKey: ["groups"],
    queryFn: fetchArticleGroups,
    staleTime: 1000 * 60, // 1 minut caching
    onError: () => errorAlert("Grupet nuk mund të shfaqen"),
  });

  // ------------------ Mutation (object form v5) ------------------
  // UnitsPage.js - React Query Mutation
  const mutation = useMutation({
    mutationFn: ({ type, id, payload }) => {
      if (type === "create") return createArticleGroup(payload);
      if (type === "update") return updateArticleGroup(payload);
      if (type === "delete") return deleteArticleGroup(id);
    },
    onSuccess: (message, variables) => {
      if (variables.type === "create")
        handleSuccess("Grupi u krijua me sukses!");
      if (variables.type === "update")
        updateAlert("Grupi u përditësua me sukses!");
      if (variables.type === "delete") deleteAlert(message);
      queryClient.invalidateQueries({ queryKey: ["groups"] });
      setIsModalOpen(false);
    },
    onError: (error, variables) => {
      let action =
        variables.type === "create"
          ? "krijimi"
          : variables.type === "update"
            ? "përditësimi"
            : "fshirja";
      errorAlert(`Dështoi ${action}: ${error.message}`);
    },
  });

  // ------------------ Handlers ------------------
  const handleAddClick = () => {
    setEditingGroups(null);
    setIsModalOpen(true);
  };

  const handleEditClick = (group) => {
    setEditingGroups(group);
    setIsModalOpen(true);
  };

  const handleDeleteClick = (deleteItemId) => {
    mutation.mutate({ type: "delete", id: deleteItemId });
  };

  const handleSave = (data) => {
    mutation.mutate({
      type: editingGroups ? "update" : "create",
      id: editingGroups?.GroupID,
      payload: data,
    });
  };

    const ArticleGroupGridHeader = [
        { field: 'id', headerName: '#', width: 70, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'name', headerName: 'Emri i Grupit', width: 1000, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'active', headerName: 'Statusi', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    ]

    const rows = articleGroups.map((item, index) => ({
        id: ++index,
        name: item.GroupName,
        active: (item.IsActive ? "Aktiv" : "Jo-Aktiv"),
        deleteItemId: item.GroupID,
        rowInfo: item
    }));

  return (
<div className="AGP__page">

      <CrudPageHeader
        icon={Package}
        title="Grupet e Artikujve"
        description="Menaxhoni, shtoni, modifikoni dhe fshini grupet e artikujve në mënyrë efikase."
        tutorialLabel="Shiko Tutorialin"
        onTutorialClick={() => infoAlert("Tutorial së shpejti!")}
        action={
          <AddAnElementButton
            className="AGP__btn-primary"
            text="Grup i Ri"
            icon={<Plus size={16} />}
            onClick={handleAddClick}
          />
        }
        className="AGP__header"
      />

      <DataGridWithActions
        columns={ArticleGroupGridHeader}
        rows={rows}
        handleEdit={handleEditClick}
        handleDelete={handleDeleteClick}
        showPayment={false}
        height={500}
      />

      {/* Modal */}
      <ArticleGroupModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSave}
        initialData={editingGroups}
      />
    </div>
  );
}
